import useIsMobile from '../hooks/useIsMobile';
import { MOBILE_EDGE } from '../theme';
import { SECTION_PATHS } from '../routes';

const ITEMS = [
    ['home', 'Home'],
    ['projects', 'Projects'],
    ['skills', 'Skills'],
    ['blog', 'Blog'],
    ['contact', 'Contact'],
];

export default function NavRail({ view }) {
    const mobile = useIsMobile();

    return (
        <nav
            aria-label="Primary"
            className="sig-nav"
            style={{
                position: 'absolute',
                display: 'flex',
                flexDirection: mobile ? 'row' : 'column',
                pointerEvents: 'auto',
                ...(mobile
                    ? {
                        left: `${MOBILE_EDGE}px`, right: `${MOBILE_EDGE}px`,
                        bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))',
                        gap: '4px', zIndex: 10, paddingTop: '10px',
                        borderTop: '1px solid color-mix(in oklab, currentColor 20%, transparent)',
                    }
                    : { left: '68px', bottom: '60px', gap: '15px' }),
            }}
        >
            {ITEMS.map(([key, label]) => {
                return (
                <a
                    key={key}
                    href={SECTION_PATHS[key] || '/blog'}
                    aria-current={view === key ? 'page' : undefined}
                    style={{
                        display: 'flex',
                        textDecoration: 'none',
                        alignItems: 'center',
                        justifyContent: mobile ? 'center' : 'flex-start',
                        flex: mobile ? '1 1 0' : undefined,
                        minHeight: mobile ? '44px' : undefined,
                        background: 'none', border: 0, color: 'inherit', font: 'inherit',
                        gap: mobile ? '7px' : '12px',
                        cursor: 'pointer',
                        width: 'max-content',
                        // A little tap room without moving the label's baseline.
                        padding: mobile ? '3px 0' : 0,
                    }}
                >
                    <span
                        style={{
                            fontSize: mobile ? '13px' : '14px',
                            fontWeight: 600,
                            letterSpacing: '.01em',
                            color: 'inherit',
                            opacity: view === key ? 1 : 0.7,
                            transition: 'opacity .3s ease',
                        }}
                    >
                        {label}
                    </span>
                    {!mobile && <span aria-hidden="true"
                        style={{
                            fontSize: '14px',
                            color: 'var(--accent)',
                            opacity: view === key ? 1 : 0,
                            transition: 'opacity .3s ease',
                        }}
                    >
                        ·
                    </span>}
                </a>
            ); })}
        </nav>
    );
}
